import React from 'react';

export default React.memo(function ButtonOutlined({ className = '', children, ...props }) {
  return (
    <button {...props} className={`border border-black p-2.5 hover:opacity-80 rounded-lg inline-block select-none ${className}`}>
      {children}
    </button>
  )
})
